import React from "react";
import ReactMarkdown from "react-markdown";

const AcademySection3 = ({ academy }) => {
  if (
    !academy.academyCourse1 &&
    !academy.academyCourse2 &&
    !academy.academyCourse3
  ) {
    return null;
  }
  const components = {
    h3: ({ children }) => (
      <h3 className="text-xl text-center md:text-left font-semibold text-[rgba(62,89,183,1)] md:text-gray-900 mb-4">
        {children}
      </h3>
    ),

    p: ({ children }) => (
      <p className="text-[#666666] text-center  md:text-left text-sm mb-4 max-w-2xl lg:max-w-full">
        {children}
      </p>
    ),

    br: () => <br />,
  };
  return (
    <div className="py-2 px-6 bg-white mt-10">
      <div className="container mx-auto">
        <div className="mb-12">
          <h2 className="text-xl text-left font-bold text-[rgba(62,89,183,1)] mb-4">
            Why Choose this Course ?
          </h2>
        </div>

        {academy.academyCourse1 && (
          <div className="bg-[rgba(62,89,183,0.1)] rounded-2xl p-6">
            <ReactMarkdown components={components}>
              {academy.academyCourse1}
            </ReactMarkdown>
          </div>
        )}

        {academy.academyCourse2 && (
          <div className="bg-[rgba(62,89,183,0.1)] rounded-2xl p-6 mt-10">
            <ReactMarkdown components={components}>
              {academy.academyCourse2}
            </ReactMarkdown>
          </div>
        )}

        {academy.academyCourse3 && (
          <div className="bg-[rgba(62,89,183,0.1)] rounded-2xl p-6 mt-10">
            <ReactMarkdown components={components}>
              {academy.academyCourse3}
            </ReactMarkdown>
          </div>
        )}
      </div>
      <div className="border-t border-b-gray-100 border border-gray-100 mt-2"></div>
    </div>
  );
};
export default AcademySection3;
